document.addEventListener("rebuy.ready", (event) => {
  const handleize = (str) =>
    str
      ?.toLowerCase()
      ?.trim()
      ?.replace(/[^a-z0-9]+/g, "-")
      ?.replace(/^-+|-+$/g, "");
  const { widget } = event.detail;
  if (widget) {
    const products = widget.data?.products;
    if (products && products?.length) {
      for (const product of products) {
        const productCard = document.querySelector(
          `#rebuy-widget-${widget.id} .rebuy-product-block.product-id-${product.id}`,
        );
        if (productCard) {
          const title = productCard.querySelector(".rebuy-product-title");
          if (title) {
            const vendorText = product.metafields?.custom?.pattern;
            if (!vendorText || vendorText.toString().trim() === "") continue;
            const vendor = document.createElement("a");
            vendor.innerText = vendorText;
            vendor.setAttribute(
              "href",
              `/collections/${handleize(vendorText)}`,
            );
            const paragraph = document.createElement("p");
            paragraph.classList.add("rebuy-product-vendor");
            paragraph.append(vendor);
            title.after(paragraph);
          }
        }
      }
    }
  }
});

// Custom element so the collection description re-initializes when the collection
// section is re-rendered by faceting/pagination (inline scripts don't run then).
class CollectionDescriptionReadMore extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector(
      ".collection-description__read-more-content",
    );
    this.toggle = this.querySelector("[data-read-more-toggle]");
    this.toggleText = this.toggle?.querySelector("[data-read-more-text]");

    if (!this.content || !this.toggle || !this.toggleText) return;

    this.collectionTitle = this.dataset.collectionTitle || "";
    this.onToggleClick = this.onToggleClick.bind(this);
    this.onResize = this.onResize.bind(this);
    this.checkOverflow = this.checkOverflow.bind(this);
    this.pendingStylesheets = [];

    this.toggle.addEventListener("click", this.onToggleClick);
    window.addEventListener("resize", this.onResize);

    this.checkOverflow();
    this.recheckWhenStylesApply();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener("click", this.onToggleClick);
    window.removeEventListener("resize", this.onResize);
    this.pendingStylesheets?.forEach((link) =>
      link.removeEventListener("load", this.checkOverflow),
    );
    this.pendingStylesheets = [];
    clearTimeout(this.resizeTimer);
  }

  // collection.css is loaded from inside the section, so a section re-render (pagination,
  // filters) re-inserts the link and the clamp styles aren't applied on the first measurement.
  recheckWhenStylesApply() {
    const scope = this.closest(".shopify-section") || document;

    scope.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
      if (link.sheet) return;
      link.addEventListener("load", this.checkOverflow, { once: true });
      this.pendingStylesheets.push(link);
    });

    document.fonts?.ready.then(() => {
      if (this.isConnected) this.checkOverflow();
    });
  }

  checkOverflow() {
    if (this.content.classList.contains("is-expanded")) return;

    this.content.classList.remove("is-truncated");
    const fullHeight = this.content.scrollHeight;
    this.content.classList.add("is-truncated");
    const visibleHeight = this.content.clientHeight;

    this.toggle.hidden = fullHeight <= visibleHeight + 5;
  }

  collapse() {
    this.content.classList.remove("is-expanded");
    this.content.classList.add("is-truncated");
    this.toggle.setAttribute("aria-expanded", "false");
    this.toggle.setAttribute(
      "aria-label",
      `Read more about ${this.collectionTitle}`,
    );
    this.toggleText.textContent = "Read more";
  }

  expand() {
    this.content.classList.remove("is-truncated");
    this.content.classList.add("is-expanded");
    this.toggle.setAttribute("aria-expanded", "true");
    this.toggle.setAttribute(
      "aria-label",
      `Read less about ${this.collectionTitle}`,
    );
    this.toggleText.textContent = "Read less";
  }

  onToggleClick() {
    if (this.content.classList.contains("is-expanded")) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      if (this.content.classList.contains("is-expanded")) {
        this.collapse();
      }
      this.checkOverflow();
    }, 250);
  }
}

if (!window.customElements.get("collection-description-read-more")) {
  window.customElements.define(
    "collection-description-read-more",
    CollectionDescriptionReadMore,
  );
}
